<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/config/parameter/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('canshubianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('canshumingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary" v-if="ids == null">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/parameter/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('canshuleixing')" required="required">
						<yi_dictionary_select :type="'PARAMETER_TYPE'" :ids.sync="yt.editObj.typeId">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('canshubianma')" required="required">
						<el-input v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('canshumingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhi')" required="required">
						<el-input v-model="yt.editObj.value"></el-input>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="yt.editObj.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4}">
						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/parameter/create', null, fetchData)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder"  :label="$t('canshuleixing')">
						<yi_dictionary_select disabled :type="'PARAMETER_TYPE'" :ids.sync="yt.editObj.typeId">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('canshubianma')">
						<el-input disabled v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('canshumingcheng')">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhi')">
						<el-input v-model="yt.editObj.value"></el-input>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="yt.editObj.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4}">
						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/parameter/update', null, fetchData)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	
	export default {
		name: 'admin_global_params_list',
		
		data() {
			return {
				columns: [{
					label: 'canshuleixing',
					prop: 'typeId',
					type: 'dictionary',
					key: 'PARAMETER_TYPE',
					width: 130
				}, {
					label: 'canshubianma',
					prop: 'code',
					width: 130
				}, {
					label: 'canshumingcheng',
					prop: 'name'
				}, {
					label: 'zhi',
					prop: 'value'
				}, {
					label: 'beizhu',
					prop: 'remark'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.get(1)
			}, 300)
		},
		methods: {
		
		}
	};
</script>
